import { mainFetch } from "../mainFetch"

const SERVICE_URL = '/provider'

const fetchService = async ({ url, ...params }) =>
    await mainFetch({ url: SERVICE_URL + url, ...params })
        .catch(e => { console.log(e); throw (e) });

export default class ProviderInfoApi {

    static async getAll({ data = undefined, ...params }) {
        return await fetchService({ url: '/getprovidersinfo', method: 'GET', data, notify: { success: false }, ...params })
    }

    static async formStat({ data = { market: undefined }, ...params }) {
        return await fetchService({ url: '/formstat', method: 'POST', data, ...params })
    }

    static async excelStat({ data = { market: undefined }, ...params }) {
        return await fetchService({ url: '/excelstat', method: 'POST', data, options: { download: true }, ...params })
    }

    // static async initProviders({ data = undefined, ...params }) {
    //     return await fetchService({ url: '/initproviders', method: 'POST', data, ...params })
    // }

    static async changeProvider({ data = { providerId: undefined, data: undefined }, ...params }) {
        return await fetchService({ url: '/changeprovider', method: 'PATCH', data, ...params })
    }

    static async addProvider({ data = { name: undefined, id: undefined, prefix: undefined, is_stock: undefined }, ...params }) {
        return await fetchService({ url: '/addprovider', method: 'POST', data, ...params })
    }



    static async allowAutoUpdate({ data = { status: undefined, providerId: undefined }, ...params }) {
        return await fetchService({ url: '/allowautoupdate', method: 'POST', data, ...params })
    }


}